
import { ActionIdEnum } from "src/app/core/enums/list-layout/action-id-enum";
import { ButtonIdEnum } from "src/app/core/enums/list-layout/button-id-enum";
import { ButtonTypeEnum } from "src/app/core/enums/list-layout/button-type-enum";
import { ColumnTypeEnum } from "src/app/core/enums/list-layout/column-type-enum";
import { GlobalComponent } from "src/app/global-component";
import { TableConfigurationModel } from "src/app/core/models/table/table-configuration.model";
import { SortByValuesModel } from "src/app/core/models/table/sort-by-values.model";
import { NgSelectListModel } from "src/app/core/models/ng-select-list.model";
import { SecurityOperations } from "src/app/core/security/security-operations";
import { RequisitionStatus } from "src/app/core/enums/requisition-status-enum";
import { TableRequisitionFilter } from "../../requisition-list/configs/table-requisition-filter-config-enum";
import { FilterPredicateEnum } from "src/app/core/enums/filter-predicate-enum";

export class ClientRequisitionListConfig extends TableConfigurationModel {

    constructor() {
        super();
        this.canConfigBeSavedToServer = true;
        this.listTitle = "Client Requisition List";
        this.customizedListTitle = "  ";
        this.pageSizeFilter = [
            { pageSize: GlobalComponent.defaultPagingInfo.pageSize },
            { pageSize: 25 },
            { pageSize: 50 }
        ]
        this.columns = [
            {
                visible: 'true',
                order: 0,
                width: "15px",
                type: ColumnTypeEnum.CheckBox,
            },
            {

                dataFieldName: 'number',
                title: 'Requisition #',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 1,
                width: "180px",
                type: ColumnTypeEnum.PhotoModel,

                underTextDataFieldName: 'type',
                imageUrlLink: true
            },
            {
                dataFieldName: 'client',
                title: 'Client',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 2,
                width: "220px",
                type: ColumnTypeEnum.SubPhotoModel,
                subDataFieldName: 'fullName',
                underTextDataFieldName: 'email',
            },

            {
                dataFieldName: 'account',
                title: 'Contact',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 3,
                width: "180px",
                type: ColumnTypeEnum.SubPhotoModel,
                subDataFieldName: 'fullName',
                underTextDataFieldName: 'companyName'
            },
            {
                dataFieldName: 'createdBy',
                title: 'Created By',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 4,
                width: "180px",
                type: ColumnTypeEnum.SubPhotoModel,
                subDataFieldName: 'fullName',
                underTextDataFieldName: 'email'

            },
            {
                dataFieldName: 'modifiedDate',
                title: 'Last Modified',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 5,
                width: "120px",
                type: ColumnTypeEnum.Date,
            },
            {
                dataFieldName: 'status',
                title: 'Status',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 6,
                width: "105px",
                type: ColumnTypeEnum.StatusCustom,
                customStatusClass: {
                    type: undefined,
                    switchOptions: [
                        { case: `${RequisitionStatus.Draft}`, return: 'coloredTextArea purple' },
                        { case: `${RequisitionStatus.SignaturePending}`, return: 'coloredTextArea teal' },
                        { case: `${RequisitionStatus.Submitted}`, return: 'coloredTextArea blue' },
                        { case: `${RequisitionStatus.Processing}`, return: 'coloredTextArea orange' },
                        { case: `${RequisitionStatus.Completed}`, return: 'coloredTextArea green' },
                        { case: `${RequisitionStatus.Incompleted}`, return: 'coloredTextArea red' },
                        { case: undefined, return: 'coloredTextArea red' }
                    ]
                },
                customStatusText: {
                    type: undefined,
                    switchOptions: [
                        { case: `${RequisitionStatus.Draft}`, return: 'Draft' },
                        { case: `${RequisitionStatus.SignaturePending}`, return: 'Signature Pending' },
                        { case: `${RequisitionStatus.Submitted}`, return: 'Submitted' },
                        { case: `${RequisitionStatus.Processing}`, return: 'Processing' },
                        { case: `${RequisitionStatus.Completed}`, return: 'Completed' },
                        { case: `${RequisitionStatus.Incompleted}`, return: 'Incompleted' },
                        { case: undefined, return: 'Other' }
                    ]
                }
            },
            {
                dataFieldName: 'total',
                title: 'Total',
                visible: 'true',
                order: 7,
                width: "100px",
                type: ColumnTypeEnum.Amount,
            },
            {
                dataFieldName: 'matterNumber',
                title: 'Requisition Matter',
                visible: 'false',
                order: 8,
                width: "125px",
                type: ColumnTypeEnum.String,
            },
            {
                dataFieldName: 'client',
                title: 'Client Matter',
                sortable: new SortByValuesModel,
                visible: 'false',
                order: 9,
                width: "125px",
                type: ColumnTypeEnum.ValueInSubModel,
                subDataFieldName: 'matterNumber',
            },
            {
                dataFieldName: 'client',
                title: 'Client Phone Number',
                sortable: new SortByValuesModel,
                visible: 'false',
                order: 10,
                width: "175px",
                type: ColumnTypeEnum.ValueInSubModel,
                subDataFieldName: 'phoneNumber',
            },
            {
                dataFieldName: 'account',
                title: 'Contact Email',
                sortable: new SortByValuesModel,
                visible: 'false',
                order: 11,
                width: "175px",
                type: ColumnTypeEnum.ValueInSubModel,
                subDataFieldName: 'email',
            },
            {
                dataFieldName: 'account',
                title: 'Contact Phone Number',
                sortable: new SortByValuesModel,
                visible: 'false',
                order: 12,
                width: "175px",
                type: ColumnTypeEnum.ValueInSubModel,
                subDataFieldName: 'phoneNumber',
            },
            {
                dataFieldName: 'account',
                title: 'Contact Fax Number',
                sortable: new SortByValuesModel,
                visible: 'false',
                order: 13,
                width: "175px",
                type: ColumnTypeEnum.ValueInSubModel,
                subDataFieldName: 'faxNumber',
            },
            {
                title: 'Actions',
                visible: 'true',
                order: 14,
                width: "125px",
                type: ColumnTypeEnum.Action
            },
        ]

        this.searchbarFilter = undefined;

        this.filters = [
            {
                label: TableRequisitionFilter.RequisitionStatusFilter,
                options: [
                    new NgSelectListModel(undefined, $localize`:@@:All Requests`, undefined, undefined, true),
                    new NgSelectListModel(RequisitionStatus.Draft, $localize`:@@:Draft`, undefined, "bx bx-shopping-bag"),
                    new NgSelectListModel(RequisitionStatus.SignaturePending, $localize`:@@:Signature Pending`, undefined, "bx bx-pencil"),
                    new NgSelectListModel(RequisitionStatus.Submitted, $localize`:@@:Submitted`, undefined, "bx bx-layer-plus"),
                    new NgSelectListModel(RequisitionStatus.Processing, $localize`:@@:Processing`, undefined, "bx bx-repeat"),
                    new NgSelectListModel(RequisitionStatus.Completed, $localize`:@@:Completed`, undefined, "bx bx-check-circle"),
                    new NgSelectListModel(RequisitionStatus.Incompleted, $localize`:@@:Incompleted`, undefined, "bx bx-error-alt"),
                ],
                selectedOption: undefined,
                inDropdown: false,
                inHeading: true,
                inButton: false,
            }
        ]

        this.actions = [
            {
                visible: SecurityOperations.requisition.requisitionUpdate,
                label: 'View',
                actionId: ActionIdEnum.View,
                icon: 'ri-eye-fill',
                inDropdown: true,
                inList: true,
                visibleOnValues: [`${RequisitionStatus.Completed}`, `${RequisitionStatus.Incompleted}`],
                dataFieldName: 'status'
            },
            {
                visible: SecurityOperations.requisition.requisitionUpdate,
                label: 'Edit',
                actionId: ActionIdEnum.Edit,
                icon: 'ri-edit-line',
                inDropdown: true,
                inList: true,
                visibleOnValues: [`${RequisitionStatus.Draft}`, `${RequisitionStatus.Submitted}`, `${RequisitionStatus.Processing}`, `${RequisitionStatus.SignaturePending}`],
                dataFieldName: 'status'
            },
            {
                visible: SecurityOperations.requisition.requisitionUpdate,
                label: 'Notes',
                actionId: ActionIdEnum.Notes,
                icon: 'ri-file-list-2-fill',
                inDropdown: true,
                inList: false,
                visibleOnValues: [`${RequisitionStatus.Submitted}`, `${RequisitionStatus.Processing}`, `${RequisitionStatus.Completed}`, `${RequisitionStatus.Incompleted}`],
                dataFieldName: 'status'
            },
            {
                visible: SecurityOperations.requisition.requisitionDelete,
                label: 'Delete',
                actionId: ActionIdEnum.Delete,
                icon: 'ri-delete-bin-fill',
                inDropdown: true,
                inList: false,
                visibleOnValues: [`${RequisitionStatus.Draft}`],
                dataFieldName: 'status'
            },

        ]

        this.buttons = [
            {
                visible: 'true',
                label: "Export",
                action: ButtonIdEnum.None,
                color: "btn-soft-info",
                iconIsAfterLabel: true,
                icon: "ri-mo re-2-fill",
                type: ButtonTypeEnum.Dropdown,
                actions: [
                    {
                        text: $localize`:@@Export_Excel:Export to Excel`,
                        value: `${ButtonIdEnum.ExportExcel}`,
                        color: 'btn-soft-primary',
                        visible: `true`
                    },
                    {
                        text: $localize`:@@Export_CSV:Export to CSV`,
                        value: `${ButtonIdEnum.ExportCSV}`,
                        color: 'btn-soft-primary',
                        visible: `true`
                    },
                ]
            }
        ]
    }
}